import React from 'react';
import { formatDate } from 'src/utils/Date';
import { useTranslation } from 'react-i18next';

const ConfirmDate = ({ yearMonth, paymentDate }) => {
  const { t } = useTranslation();
  return ( 
    <div>
      {yearMonth} {t('features.EmployeePays.components.ConfirmDate.Confirm_salary')}<br />
      ({t('features.EmployeeBonus.ShowBonusFbDataPage.payment_date')} : {formatDate(paymentDate)})
      <br />
      <br />
    </div>
  );
};

export default ConfirmDate;
